import { createContext, useState } from "react";

import { AuthService } from ".";
import { SignInError } from "./errors";

export const AuthContext = createContext({
  signIn: () => {},
  signOut: () => {},
  signUp: () => {},
  getSession: () => {},
});

export default function AuthProvider({ children }) {
  const [session, setSession] = useState(null);

  const signIn = async ({ email }) => {
    const { error } = await AuthService.signIn({ email });
    if (error) throw new SignInError();
  };

  const verifyOtp = async ({ code, email }) => {
    const { data, error } = await AuthService.verifyOtp({ code, email });
    if (error) throw new SignInError();

    setSession(data.session);
  };

  const signOut = async () => {
    await AuthService.signOut();
    setSession(null);
  };

  const getSession = async () => {
    if (!session) {
      const { data } = await AuthService.getSession();
      if (!data.session) {
        return null;
      }
      setSession(data.session);
      return data.session;
    }
    return session;
  };

  return (
    <AuthContext.Provider
      value={{
        signIn,
        signOut,
        getSession,
        signUp: AuthService.signUp,
        verifyOtp,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
